import { render, staticRenderFns } from "./MainPanel.vue?vue&type=template&id=254d697e&scoped=true&"
import script from "./MainPanel.vue?vue&type=script&lang=ts&"
export * from "./MainPanel.vue?vue&type=script&lang=ts&"
import style0 from "./MainPanel.vue?vue&type=style&index=0&id=254d697e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254d697e",
  null
  
)

export default component.exports